import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import Box from '@mui/material/Box';
import HelpCard from '../../../components/common/HelpCard';
import SuccessPopup from '../../../components/common/SuccessPopup';
import {useRenewalClick} from '../context/RenewalClickContext';
import {handleContactClick} from '../api/renewalClickApi';

/**
 * Renewal Click's help card, wired to the shared contact-clicked backend flow.
 * Phone requests a callback (Salesforce notification to the renewal team) and
 * shows a success popup; WhatsApp only opens the chat and never notifies.
 */
const RenewalHelpCard = ({title, description, sx}) => {
  const intl = useIntl();
  const m = (id) => intl.formatMessage({id});
  const {opportunityId, currentScreen, contact} = useRenewalClick();
  const [showSuccess, setShowSuccess] = useState(false);

  const whatsAppNumber = contact.whatsAppNumber;

  const onPhone = async () => {
    if (!opportunityId) return;
    const success = await handleContactClick(opportunityId, currentScreen, 'phone');
    if (success) setShowSuccess(true);
  };
  const onWhatsApp = () => {
    if (opportunityId) handleContactClick(opportunityId, currentScreen, 'whatsapp');
  };

  return (
    <>
      <Box sx={sx}>
        <HelpCard
          title={title}
          description={description}
          whatsappLabel={m('renewalClick.helpWhatsapp')}
          callLabel={m('renewalClick.helpCall')}
          whatsappHref={whatsAppNumber ? `https://wa.me/${whatsAppNumber}` : undefined}
          onWhatsapp={onWhatsApp}
          onCall={onPhone}
        />
      </Box>
      <SuccessPopup
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        title={m('renewalClick.contactSuccess.title')}
        description={m('renewalClick.contactSuccess.description')}
      />
    </>
  );
};

RenewalHelpCard.propTypes = {
  description: PropTypes.string.isRequired,
  sx: PropTypes.object,
  title: PropTypes.string.isRequired,
};

export default RenewalHelpCard;
